import * as React from "react";
const SvgFiRrFail = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 3H5C2.243 3 0 5.243 0 8v8c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V8c0-2.757-2.243-5-5-5m3 13c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM7 8.777v.045a.777.777 0 0 1-.777.777H5.6V11.4h.623c.429 0 .777.348.777.777v.045a.777.777 0 0 1-.777.777H5.6v2.223a.777.777 0 0 1-.777.777c-.429 0-.822-.348-.822-.777V8.777c0-.429.348-.777.777-.777h1.445c.429 0 .777.348.777.777m13 6.4v.045a.777.777 0 0 1-.777.777h-1.445a.777.777 0 0 1-.777-.777V8.777c0-.429.393-.777.822-.777s.777.348.777.777V14.4h.623c.429 0 .777.348.777.777m-4.4-6.4v6.445a.777.777 0 0 1-.777.777c-.429 0-.823-.348-.823-.777V8.777c0-.429.393-.777.823-.777s.777.348.777.777m-4.474-.61a1.602 1.602 0 0 0-1.534.057c-.471.277-.809.776-.926 1.356l-1.165 5.479a.777.777 0 0 0 1.519.329l.175-.79h2.379l.165.782c.076.36.437.617.804.617a.777.777 0 0 0 .761-.937l-1.142-5.435c-.135-.668-.523-1.213-1.035-1.459zm-1.578 4.832.686-3.104c.03-.149.105-.253.176-.296l.017.006c.024.016.121.118.168.349l.641 3.044z"
    />
  </svg>
);
export default SvgFiRrFail;
